export interface DeckEntry {
  category: string;
  preset: string;
}

/**
 * Style and use-case categories only — format buckets (image-to-video,
 * transitions, lyria) and seasonal ones are excluded on purpose: the first
 * answer "do you like video", the second expire.
 */
const DEFAULT_ONBOARDING_DECK: DeckEntry[] = [
  { category: '3d-characters', preset: 'motivating-gym-character' },
  { category: 'ai-dance-generator', preset: 'kavkaz-dance-trend' },
  { category: 'cartoonify', preset: 'your-astronaut-toy-video' },
  { category: 'cinematic-character-scenes', preset: 'hellfire-ninja-stance' },
  { category: 'anime-scenes', preset: 'manga-volume-cover' },
  { category: 'funny-filters', preset: 'toddler-tantrum-video' },
  { category: 'mood-edits', preset: 'dramatic-cry-loop' },
  { category: 'video-game-styles', preset: 'ps2-3d-character' },
  { category: 'ai-food-world', preset: 'candy-crash-video-effect' },
  { category: 'zodiac-sign-transformations', preset: 'gemini-zodiac-portrait' },
  { category: 'professional-profile', preset: 'creative-noir' },
  { category: 'love-and-flowers', preset: 'festive-couture-editorial' },
];

export default DEFAULT_ONBOARDING_DECK;
